var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurvedlogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 773,
    height: 153,
    viewBox: "0 0 773 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H472.206C484.783 0 496.627 5.91494 504.183 15.9689L557.131 86.4237C564.687 96.4776 576.531 102.393 589.108 102.393H733C755.091 102.393 773 120.301 773 142.393V152V152C773 152.276 772.776 152.5 772.5 152.5H0V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedlogin);
export default __webpack_public_path__ + "static/media/curvedlogin.7c577f7acc2b002b0a067834a41533c9.svg";
export { ForwardRef as ReactComponent };